import React, { useMemo } from 'react';

import { Descriptions, DescriptionsProps, Divider, Modal } from 'antd';

import dayjs from 'dayjs';
import { DATETIME_CLIENT_FORMAT } from 'internal-constants';
import { makeVehiclePlate } from 'lib/helpers/Domain.helper';
import { Guest } from 'types/Guest.type';

type Props = {
    vehicle: Guest.Vehicle.Model,
    onCancel: () => void,
};

export function GuestVehicleDetailsModal({ vehicle, onCancel }: Props) {
    const formattedPlate = makeVehiclePlate(vehicle.plate);

    const title = ['Detalhes do veículo', formattedPlate].join(' ');

    const items: DescriptionsProps['items'] = useMemo(() => {
        return [
            {
                key: 'id',
                label: 'ID',
                children: vehicle.id,
            },

            {
                key: 'brand',
                label: 'Marca',
                children: vehicle.brand,
            },

            {
                key: 'model',
                label: 'Modelo',
                children: vehicle.model,
            },

            {
                key: 'color',
                label: 'Cor',
                children: vehicle.color,
            },

            {
                key: 'plate',
                label: 'Placa',
                children: formattedPlate,
            },

            {
                key: 'created_at',
                label: 'Cadastrado em',
                children: dayjs(vehicle.created_at).format(DATETIME_CLIENT_FORMAT),
            },
        ];
    }, [formattedPlate, vehicle.brand, vehicle.color, vehicle.created_at, vehicle.id, vehicle.model]);

    return (
        <Modal
            open
            width={610}
            title={title}
            onCancel={onCancel}
            footer={null}
        >
            <Divider />

            <Descriptions
                items={items}
                column={3}
                layout="vertical"
                bordered
            />
        </Modal>
    );
}
